import { useEffect } from "react";
import { useAuth } from "oidc-react";

const SilentRenew = () => {
  const { userManager } = useAuth();
  useEffect(() => {
    userManager.signinSilentCallback().catch(console.error);
    console.log("user", userManager)
    // alert("silent renew called")
  }, []);

  return null;
};

export default SilentRenew;